import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { CompaniesListContainer } from './containers/companies-list/companies-list.container';

export const CompanyModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.COMPANY_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.COMPANY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.COMPANY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={CompaniesListContainer}
      />
    </>
  );
};
